import { emailOTPClient, inferAdditionalFields, lastLoginMethodClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { getAcceptLanguage } from '@/lib/utils';

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL,
  plugins: [
    emailOTPClient(),
    lastLoginMethodClient(),
    inferAdditionalFields({
      user: {
        roles: { type: 'string[]', input: false },
      },
    }),
  ],
  fetchOptions: {
    onRequest(ctx) {
      ctx.headers.set('Accept-Language', getAcceptLanguage());
    },
  },
});
